$(window).on('load', () => {

	//autoopen form
	var hash = window.location.hash.substr(1);

	if (hash.includes('participant')) {

		setTimeout(function () {
			$('.add-fields a[type="adult"]').click();
		}, 500);

	}

	if (hash.includes('team')) {

		setTimeout(function () {
			$('.add-fields a[type="estafeta"]').click();
		}, 500);

	}

	if (hash.includes('-')) {

		setTimeout(function () {
			$('.block.num-0 .distances li:nth-of-type(' + hash.split('-')[1] + ')').click();
		}, 1500);
	}



	// checkout page autofill

	if ($('.woocommerce-checkout.woocommerce-page form.woocommerce-checkout').length) {

		let input = JSON.parse(localStorage.getItem('marathons_cart'));
		if (input.marathons_participants.length == 1) { // Only if there is ONE participant. 
			//console.log(input.marathons_participants[0].runners[0]);

			for (const [key, value] of Object.entries(input.marathons_participants[0].runners[0])) {
				switch (value.name) {
					case 'reg_name':
						$('#billing_first_name').val(value.value);
						break;
					case 'reg_lastname':
						$('#billing_last_name').val(value.value);
						break;
					case 'reg_phone':
						$('#billing_phone').val(value.value);
						break;
					case 'reg_city':
						$('#billing_city').val(value.value);
						break;
					case 'reg_email':
						$('#billing_email').val(value.value);
						break;

				}

			}

		}

		prepareCheckout();
		$('.container.checkout').show();
		$('.merch-blocks').show();
	}

	//order-complete page saves cleanup 
	if ($('.woocommerce-checkout.woocommerce-page.woocommerce-order-received').length) {
		resaveCart('marathons_id', '');
		resaveCart('marathons_participants', '');
		resaveCart('marathons_merch', '');
		resaveCart('marathons_step', '');

		console.log('cleared!');
	}

	$.datepicker.setDefaults({
		closeText: 'Закрыть',
		prevText: '<Пред',
		nextText: 'След>',
		currentText: 'Сегодня',
		monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
		monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
		dayNames: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
		dayNamesShort: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
		dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
		weekHeader: 'Нед',
		dateFormat: 'dd-mm-yy',
		firstDay: 1,
		showAnim: 'slideDown',
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: '',
		changeMonth: true,
		changeYear: true,
		maxDate: 0,
		yearRange: '1950:2020'
	});


	if ($('.container.registration').length) {
		history.pushState(null, null, '');
		window.addEventListener('popstate', function (event) {
			history.pushState(null, null, '');
		});
	}


	if (window.history && window.history.pushState) {
		if ($('.subtotal').length) {
			//window.history.pushState('forward', null, './#forward');

			let step = $('.subtotal').attr('step');

			if (step == 'checkout ') {
				window.history.back();
				return;
			}

			$(window).on('popstate', function (e) {
				// console.log(e.originalEvent.state);
				$('.prevpage').click();
			});
		}

	}


	$('body').on('change', 'input.error', function (e) {
		$(this).removeClass('error');
	});

	if ($('.container.registration').length) {
		var id = $('.container.registration').attr('marathon-id');
		setCookie('marathon_id', id, '99');
		console.log('id set:  ' + id);
	}

	$('body').on('change', '.subfield select', function (e) {
		// $(this).parent().find('img').attr('src', $(this).find(":selected").attr('img'));
	});

	function authorParticipantCheck() {
		if ($(".itsme:checked").length > 1) return $(".itsme:checked");
		return false;
	}

	$('body').on('click', '.menu-toggle', function (e) {
		$('header').toggleClass('open');
	});

	function checkDisabledSnaryads(elem) {

		$(elem).find('.snaryad a').removeClass('disabled');

		$(elem).find(".snaryad a.active").each(function () {
			$(elem).find('.snaryad a[value="' + $(this).attr('value') + '"]:not(.active)').addClass('disabled');
		});

	}

	$('body').on('click', '.snaryad a', function (e) {
		e.preventDefault();

		if ($(this).hasClass('disabled')) return;

		if ($(this).hasClass('active')) {
			$(this).removeClass('active');

		} else {
			$(this).parent().find('a').removeClass('active');
			$(this).parent().parent().find('select').val($(this).attr('value'));
			$(this).parent().parent().find('.block-title select[name=estafeta-type]').change();
			$(this).addClass('active');
		}

		checkDisabledSnaryads($(this).closest('.participants'));

	});

	$('body').on('click', '.itsme', function (e) {

		let block = $(this).parent().parent().parent();
		e.preventDefault();

		let registrator = $('.registrator form').serializeArray();

		Object.entries(registrator).forEach(([key, f]) => {
			$(block).find('input[name="' + f.name + '"]').val(f.value);
		});

	});

	$('body').on('click', '.itsmychild', function (e) {

		let block = $(this).parent().parent().parent().parent();
		e.preventDefault();

		let registrator = $('.registrator form').serializeArray();

		Object.entries(registrator).forEach(([key, f]) => {
			$(block).find('input[name="parent_' + f.name + '"]').val(f.value);
		});

	});

	tippy('.subtotal .refresh', {
		content: 'Ви впевнені? <a class="refresh-yes" href="#">Так</a> <a class="no" href="#">Ні</a>',
		trigger: 'click',
		interactive: true,
	});

	$('body').on('click', '.refresh-yes', function (e) {
		e.preventDefault();

		resaveCart('marathons_id', '');
		resaveCart('marathons_participants', '');
		resaveCart('marathons_merch', '');
		resaveCart('marathons_step', '');

		console.log('cleared!');
		location.reload();
	});

	$('body').on('click', '.subtotal .refresh', function (e) {
		e.preventDefault();

	});

	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function countRunners() {
		return $('.user-blocks .block.child, .user-blocks .block.adult, .user-blocks .block.estafeta .participants .participant').length;
	}

	$('.add-fields a').on('click', function (e) {
		e.preventDefault();
	
		let num = parseInt($('.user-blocks .participant:visible').length);
		let blocknum = parseInt($('.participant:visible').length) + 1;

		let type = $(this).attr('type')

		

		let src = $('.sources .block[type="' + type + '"]').clone();
		$(src).attr('num', num);
		$(src).attr('blocknum', blocknum);
		$(src).addClass('num-' + num);


		//$(src).find('.num').text(num);

		$('.user-blocks').attr("snum", num);

		console.log('date!');
		$(src).find('.validate-date').datepicker();
		$(src).find('select[name="reg_country"]').chosen();

		let usrNum = num;

		$(src).find('.num').text(usrNum + 1);
		$(src).find('.participants .num').each(function () {  
			usrNum++;
			$(this).text(usrNum);
			
		});

		let newblock = src.appendTo(".user-blocks");

	
	

		tippy('.block.num-' + num + ' .remove', {
			content: 'Ви впевнені? <a num="' + blocknum + '" class="yes" href="#">Так</a> <a class="no" href="#">Ні</a>',
			trigger: 'click',
			interactive: true,
		});

		updateTotal();
	});

	$('body').on('click', '.add-participant', function (e) {
		e.preventDefault();

		let num = parseInt($('.user-blocks').attr("num")) + 1;
		let blocknum = parseInt($('.participant:visible').length) + 1;
		$('.user-blocks').attr("num", num);

		let src = $('.sources .block[type="estafeta"] .source .participant').clone();
		$(src).attr('num', num);
		$(src).attr('blocknum', blocknum);
		$(src).addClass('num-' + num);
		$(src).find('.num').text(num);

		console.log('date!');
		$(src).find('.validate-date').datepicker();
		$(src).find('select[name="reg_country"]').chosen();
		let target = $(this).parent().parent().find('.participants');
		src.appendTo(target);

		

		tippy('.participant.num-' + num + ' .remove', {
			content: 'Ви впевнені? <a num="' + blocknum + '" class="yes" href="#">Так</a> <a class="no" href="#">Ні</a>',
			trigger: 'click',
			interactive: true,
		});

		updateTotal();
	});


	$('body').on('click', '.tippy-content .no', function (e) {
		e.preventDefault();
		$(this).parent().parent().parent().remove();
	});
	$('body').on('click', '.tippy-content .yes', function (e) {
		e.preventDefault();
		$('.user-blocks .block[blocknum=' + $(this).attr('num') + ']').remove();

		updateTotal();
	});

	$('body').on('click', '.saveme', function (e) {
		e.preventDefault();
		$('.block').removeClass('editing');
		$('.site-content').removeClass('editing');
		$('.user-blocks .estafeta .marathon-title span').attr('contenteditable', 'false');
		updateTotal();
	});


	$('body').on('click', '.distances li', function (e) {
		e.preventDefault();
		$(this).parent().find('li').removeClass('active');
		$(this).addClass('active');

		$(this).closest('.block').find('.details .info:not(.edit) .length').html($(this).find('.length').html());
		$(this).parent().find('.selecteddistance').val($(this).find('.length').html());
		$(this).closest('.block').find('.details .info:not(.edit) span.price').html($(this).find('.price').html());

		updateTotal();
	});

	$('body').on('click', '.user-blocks .block .genderlabel', function (e) {
		//console.log($(this).attr('value'));
		$(this).parent().find('input.setnewname').val($(this).attr('value'));
		$(this).parent().find('label').removeClass('checked');
		$(this).addClass('checked');
	});

	function getTotal() {
		let total = 0;
		$('.user-blocks .block').each(function (index, value) {
			if ($(this).find('.participants').length) {

				total = total + ( parseInt($(this).find('.distances .active .price').text()) );
				//console.log(total);
			} else {
				total = total + parseInt($(this).find('.distances .active .price').text());
			}
		});

		$('.goods .product').each(function (index, value) {
			let amnt = $(this).find('.number-selector input').val();
			let val = $(this).find('.price').attr('price');
			if (amnt) {
				total = total + parseInt(amnt * parseInt(val));
			}

		});

		return total;
	}

	function updateTotal() {
		$('.subtotal span.price').text(getTotal());
		$('.total-participants span.part').text(parseInt(countRunners()));

		if ($('.user-blocks .block').length) {
			$('.site-content').addClass('hasblocks');
		} else {
			$('.site-content').removeClass('hasblocks');
		}

		var items = document.getElementsByClassName('validate-phone'); //apply phonemask
		Array.prototype.forEach.call(items, function(element) { 
			var phoneMask = new IMask(element, {
				mask: '+00(000)000-00-00',
				placeholder: {
					show: 'always'
				}
			});
		});
	}

	function showError(msg) {
		$('.error.message .msg').html(msg);
		$('.error.message').fadeIn("fast");
		setTimeout(() => $('.error.message').fadeOut("fast"), 2000);
	}

	function fieldError(field, msg) {
		$(field).addClass('error');
		$('body').scrollTo(field, 1000, {
			offset: -50
		});
		showError(msg);
	}

	function validateEmail($email) {
		var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
		return emailReg.test($email);
	}

	function validatePhone(phone) {
		if (phone.length == 17) {
			return true;
		} else { console.log(phone.length); return false; }
	}

	function validateDate(val) {

		if (!val.length) {
			return false;
		}
		//else if (Date.parse(val) - Date.parse(new Date()) < 0) // check: date is not in the past. 
		//{
		//return false;
		//} 
		else {
			return true;
		}
	}

	function getAge(dateString) {
		var today = new Date();
		var birthDate = new Date(dateString);
		var age = today.getFullYear() - birthDate.getFullYear();
		var m = today.getMonth() - birthDate.getMonth();
		if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
			age--;
		}
		return age;
	}


	function validateAge(obj) {

		let requiredAge = parseInt($(obj).closest('.col-12.block').find('.distances li.active .age').text());

		if (requiredAge > getAge($(obj).val())) return false;
		return true;

	}

	function validateFields() {

		var err = false;

		if (countRunners() < 1) {
			showError('Необхідно додати учасників!');
			err = true;
			return false;
		}

		$(".validate-text:visible").each(function () {
			$(this).removeClass('error');
			let fieldName = $(this).parent().find('label').text();

			if (!$(this).val().length) {
				fieldError($(this), 'Поле "' + fieldName + '" не може бути порожнім!');
				err = true;
				return false;
			}

			if ($(this).val().length < 2) {
				fieldError($(this), 'Поле "' + fieldName + '" занадто коротке');
				err = true;
				return false;
			}
			return true;
		});

		if (err) return;

		$(".validate-email:visible").each(function () {
			$(this).removeClass('error');

			let fieldName = $(this).parent().find('label').text();

			if (!validateEmail($(this).val())) {
				fieldError($(this), 'Поле "' + fieldName + '" містить помилку в email!');
				err = true;
				return false;
			}

		});

		if (err) return;

		$(".validate-select:visible").each(function () {
			$(this).removeClass('error');

			let fieldName = $(this).parent().parent().parent().find('.block-title > span').text();

			// console.log($(this).find(":selected").text());

			$(this).hide();

			if ($(this).find(":selected").text() == "Не Обрано") {
				if ($(this).attr('name') == 'reg_city') {
					fieldError($(this), 'Учасник ' + fieldName + ' - Не встановлено місто.');
				} else {
					fieldError($(this), 'Учасник ' + fieldName + ' - Не вибран тип учасника.');
				}

				err = true;
				return false;
			}

		});
		if (err) return;

		$(".validate-snaryad:visible").each(function () {
			$(this).removeClass('error');

			let fieldName = $(this).parent().parent().parent().find('.block-title > span').text();

			if (!($(this).find("a.active").length)) {
				fieldError($(this), 'Учасник ' + fieldName + ' - Не вибран тип учасника.');
				err = true;
				return false;
			}


		});
		if (err) return;

		$(".validate-size:visible").each(function () {
			$(this).removeClass('error');

			let fieldName = $(this).parent().parent().parent().find('.block-title > span').text();
			console.log($(this).find('option:selected').val());
			if (($(this).find('option:selected').val() == '?')) {
				fieldError($(this), 'Учасник ' + fieldName + ' - Не вибран розмір учасника.');
				err = true;
				return false;
			}


		});
		if (err) return;


		$(".validate-phone:visible").each(function () {
			$(this).removeClass('error');

			let fieldName = $(this).parent().find('label').text();

			if (!validatePhone($(this).val())) {
				fieldError($(this), 'Поле "' + fieldName + '" містить помилку в номері телефону!');
				err = true;
				return false;
			}

		});
		if (err) return;


		$(".validate-date:visible").each(function () {
			$(this).removeClass('error');

			let fieldName = $(this).parent().find('label').text();
			if (!validateDate($(this).val())) {
				fieldError($(this), 'Поле "' + fieldName + '" містить некоректну дату!');
				err = true;
				return false;
			}

			if (!validateAge($(this))) {
				fieldError($(this), 'Будь ласка, переконайтеся що ваш вік, вказаний в полі:"' + fieldName + '" підходить по обмеженням заходу');
				err = true;
				return false;
			}

		});
		if (err) return;


		if (!err) return true;
	}

	function collectfieldsData() {
		var data = [];

		$(".participants .block").each(function () {
			let num = $(this).attr('num');
			let type = $(this).attr('type')
			let distance = $(this).find('.distances li.active span.length').text();
			//console.log(distance);
			let price = parseInt($(this).find('.distances li.active .price').text());

			if (type == 'adult') {
				data.push({
					num,
					type,
					'distance': distance,
					price,
					'runners': [$(this).serializeArray()]
				});
			}

			if (type == 'child') {
				data.push({
					num,
					type,
					'distance': distance,
					price,
					'runners': [$(this).serializeArray()]
				});
			}

			if (type == 'estafeta') {

				let mParticipants = [];
				let title = $(this).find('.marathon-title span').text()

				$(this).find('.participants form').each(function () {
					let formData = $(this).serializeArray();
					let num = $(this).attr('num');
					mParticipants.push(formData);
				});

				data.push({
					num,
					type,
					'distance': distance,
					price,
					'runners': mParticipants,
					title
				});

			}


		});
		
		return data;
	}


	function collectMerch() {

		let merch = [];

		$('.goods .product').each(function (index, value) {
			let amnt = $(this).find('.number-selector input').val();
			let id = $(this).attr('pid');
			if (amnt > 0) {
				merch.push({
					id,
					amnt
				});
			}
		});

		return merch;

	}

	function resaveCart(key, value) {
		let data = JSON.parse(localStorage.getItem('marathons_cart'));
		if (!data) data = {};
		data[key] = value;
		localStorage.setItem('marathons_cart', JSON.stringify(data));

	}

	function hideAll() {
		$('.container.registration,.container.merch,.container.checkout').hide();
	}

	$('body').on('click', '.nextpage', function (e) {
		e.preventDefault();
		let step = $('.subtotal').attr('step');
		
		if (step == 'checkout') {
			let accept = true;
			if ($('.accept-row .accept').length) {
				if (!$('.accept-row .accept').is(":checked")) {
					fieldError($(this), 'Для продовження необхідно погодитися з правилами заходу.');
					accept = false
					return;
				}
			}
			if (accept) {
				$('#place_order').click();
			}
			return;
		}

		if (validateFields()) {

			resaveCart('marathons_id', $('.container.registration').attr('marathon-id'));
			resaveCart('marathons_participants', collectfieldsData());
			resaveCart('marathons_merch', collectMerch());

			if (!step) {
				hideAll();
				$('.subtotal').attr('step', 'merch');
				$('.container.merch').show();
			}

			resaveCart('marathons_step', $('.subtotal').attr('step'));
			resaveCart('marathons_event', {
				'number': $('.subtotal .total-participants span.part').text(),
				'total': $('.subtotal .total span.price').text()
			});


			if (step == "merch") {
				gotoCheckout();
			}



			if (step == "checkout") {
				gotoCheckout();
			}

		}


	});

	$('body').on('click', '.prevpage', function (e) {

		let step = $('.subtotal').attr('step');
		let backURL = $('.subtotal').attr('eventurl');
		e.preventDefault();

		if (step == '') {
			return;
		}

		if (step == 'checkout') {
			window.location.href = backURL;
			return;
		}

		if (validateFields()) {
			resaveCart('marathons_participants', collectfieldsData());
			resaveCart('marathons_merch', collectMerch());

			if (step == 'merch') {
				hideAll();
				$('.subtotal').attr('step', '');
				$('.container.registration').show();
			}

		}

		resaveCart('marathons_step', $('.subtotal').attr('step'));

	});

	function gotoCheckout() {
		let storage = JSON.parse(localStorage.getItem('marathons_cart'));

		var id = $('.container.registration').attr('marathon-id');
		var merch = storage.marathons_merch;
		var participants = storage.marathons_participants;

		setCookie('marathon_id', id, '99');

		$.ajax({
			type: "POST",
			url: ajax_var.url,
			data: {
				action: 'marathons_checkout',
				security: ajax_var.nonce,
				id,
				merch,
				participants
			},
			success: function (data) {
				console.log(data)

				if (data == 'checkout') {
					window.location.href = "/checkout/?event=" + id;
				}
			},
			error: function () {
				console.log(errorThrown); // error
			}
		});
	}


	// numbers 
	$('.minus').click(function () {
		var $input = $(this).parent().find('input');
		var count = parseInt($input.val()) - 1;
		count = count < 0 ? 0 : count;
		$input.val(count);
		$input.change();
		updateTotal();
		return false;
	});

	$('.plus').click(function () {
		var $input = $(this).parent().find('input');
		$input.val(parseInt($input.val()) + 1);
		$input.change();
		updateTotal();
		return false;
	});


	function prepareCheckout() {

		var checkoutData = JSON.parse(localStorage.getItem('marathons_cart'));

		if (checkoutData) {

			// Getting the storage shit together
			$('.participant-blocks').html('');


			Object.keys(checkoutData.marathons_participants).forEach(key => {
				var runners = checkoutData.marathons_participants[key].runners[0];
				var participant_data = [];

				checkoutData.marathons_participants[key].data = [];

				if (runners) {
					Object.keys(runners).forEach(key2 => {
						participant_data[runners[key2].name] = runners[key2].value;
					});
				}

				checkoutData.marathons_participants[key].data.push(participant_data);
			});

			let participants = checkoutData.marathons_participants;

			// actually building the layout
			Object.keys(participants).forEach(key => {

				let runner = parseInt(participants[key].participant) + 1;
				let data = participants[key].data[0];
				let src = '';

				if (participants[key].type == 'adult') {
					src = $('.checkout .source .block.adult-source').clone();
					$(src).find('.name span').text(data['reg_name'] + ' ' + data['reg_lastname']);

					if (data['gender'] == 'female') {
						$(src).find('.gender span').text('Жінка');
					} else {
						$(src).find('.gender span').text('Чоловік');
					}

					let num = parseInt(participants[key].num) + 1;
					$(src).find('h3 > span').text('Учасник ' + num);
					$(src).find('.right .price span').text(participants[key].price);
					$(src).find('.date span').text(data['reg_date']);
					$(src).find('.email span').text(data['reg_email']);
					$(src).find('.phone span').text(data['reg_phone']);

					$(src).find('.city span').text(data['reg_country'] + ', ' + data['reg_city']);
				}


				if (participants[key].type == 'child') {
					src = $('.checkout .source .block.child-source').clone();
					$(src).find('.name span').text(data['reg_name'] + ' ' + data['reg_lastname']);

					if (data['gender'] == 'female') {
						$(src).find('.gender span').text('Жінка');
					} else {
						$(src).find('.gender span').text('Чоловік');
					}

					$(src).find('h3 > span').text('Учасник ' + participants[key].num + ': Дитина');

					$(src).find('.date span').text(data['reg_date']);
					$(src).find('.email span').text(data['reg_email']);
					$(src).find('.phone span').text(data['reg_phone']);

					$(src).find('.city span').text(data['reg_country'] + ', ' + data['reg_city']);
					$(src).find('.right .price span').text(participants[key].price);

					$(src).find('.adult-phone span').text(data['parent_reg_phone']);
					$(src).find('.adult-gender span').text(data['parent_reg_gender']);
					$(src).find('.adult-email span').text(data['parent_reg_email']);
					$(src).find('.adult-name span').text(data['parent_reg_name'] + ' ' + data['parent_reg_lastname']);
				}

				if (participants[key].type == 'estafeta') {
					data = participants[key].data;
					src = $('.checkout .source .block.estafeta-source').clone();

					let runners = participants[key].runners;
					$(src).find('.right .price span').text(participants[key].price);
					$(src).find('.block-title > span').text('Эстафета: ' + participants[key].title);

					Object.keys(runners).forEach(key => {
						let rnrData = runners[key];
						let data = [];

						Object.keys(rnrData).forEach(key3 => {
							data[rnrData[key3].name] = rnrData[key3].value;
						});

						let rnr = $('.checkout .source .estafeta-fields').clone();


						if (data['gender'] == 'female') {
							$(rnr).find('.gender span').text('Жінка');
						} else {
							$(rnr).find('.gender span').text('Чоловік');
						}

						$(rnr).find('.name span').text(data['reg_name'] + ' ' + data['reg_lastname']);
						$(rnr).find('.date span').text(data['reg_date']);
						$(rnr).find('.email span').text(data['reg_email']);
						$(rnr).find('.phone span').text(data['reg_phone']);
						$(rnr).find('.city span').text(data['reg_country'] + ', ' + data['reg_city']);

						$(rnr).find('h5 > span').text('Учасник ' + (parseInt(key) + 1));

						let img = '';
						if (data['estafeta-type'] == 'Велосипед') {
							img = 'biker.svg';
						} else if (data['estafeta-type'] == 'Біг') {
							img = 'runner.svg';
						} else if (data['estafeta-type'] == 'Плавання') {
							img = 'swimmer.svg';
						}



						$(rnr).find('h5 > img').attr('src', '/wp-content/themes/marathons/img/' + img);
						$(src).find('.runner-fields').append(rnr);


					});

				}

				$('.participant-blocks').append(src);

			});


			//merch

			let totalMerch = 0;
			$('.merch-blocks .cart-merch').html('');

			checkoutData.marathons_merch.forEach(function (cart_entry) {
				let src = $('.product[pid="' + cart_entry.id + '"]').clone();
				let price = parseInt($(src).find('.buy .price').attr('price')) * cart_entry.amnt;
				$(src).find('.total span').text(price);
				$(src).find('.amnt').text('x' + cart_entry.amnt);
				totalMerch += price;
				$('.merch-blocks .cart-merch').append(src);
			});

			$('.merch-blocks .right .price span').text(totalMerch);

			if (totalMerch > 0) {
				$('.merch-blocks').show();
			}
		}

	}

	function restoreCart(input) {
		if (input) {

			if ((input.marathons_id !== $('.container.registration').attr('marathon-id'))) return;
			// console.log(input);

			//spawn merch
			if (input.marathons_merch) {

				for (const [key, item_data] of Object.entries(input.marathons_merch)) {
					//console.log(item_data);
					$('.container.merch .goods .product[pid=' + item_data.id + ']').find('.amount .number-selector.number input').val(item_data.amnt);
				}

				updateTotal();

			}

			//spawn participants

			if (input.marathons_participants) {
				//	console.log(input.marathons_participants);

				for (const [key, participant] of Object.entries(input.marathons_participants)) {
					//console.log(participant);

					let rnd = Math.floor(Math.random() * 111111);
					let num = parseInt($('.user-blocks .participant:visible').length);
					let blocknum = parseInt($('.participant:visible').length) + 1;

					$('.user-blocks').attr("snum", num);
					// $('.sources .estafeta .participants .participant').detach();

					let src = $('.sources .block[type="' + participant.type + '"]').clone();
					$(src).attr('num', num);
					$(src).attr('blocknum', blocknum);
					$(src).addClass('num-' + num);

					$(src).find('.validate-date').datepicker();

					

					let usrNum = num;

					$(src).find('.num').text(usrNum + 1);

					let newblock = src.appendTo(".user-blocks");

					tippy('.block.num-' + num + ' .remove', {
						content: 'Ви впевнені? <a num="' + blocknum + '" class="yes" href="#">Так</a> <a class="no" href="#">Ні</a>',
						trigger: 'click',
						interactive: true,
					});

					$(src).find('.distances li[price=' + participant.price + ']').click();
					$(src).find('.participants').html('');
					var numm = 0;
					if (participant.type == 'estafeta') {

						//console.log(participant.type);
						participant.runners.forEach(function (field_obj) {
							//console.log(field_obj);
							numm++;

							//console.log(numm);

							let num = parseInt($('.user-blocks .participant:visible').length);

							let blocknum = parseInt($('.participant:visible').length) + 1;
							$('.user-blocks').attr("num", num);

							let esrc = $('.sources .block[type="estafeta"] .source .participant').clone();
							$(esrc).attr('num', num);
							$(esrc).attr('blocknum', blocknum);
							$(esrc).addClass('num-' + num);

							let usrNum = num;
						
							$(esrc).find(' .num').each(function () {  
								usrNum++;
								$(this).text(usrNum);
								
							});


							//let esrc = $(src).find('.participants .participant:nth-child('+numm+')');
							$(esrc).find('.validate-date').datepicker();

							tippy('.participant.num-' + num + ' .remove', {
								content: 'Ви впевнені? <a num="' + blocknum + '" class="yes" href="#">Так</a> <a class="no" href="#">Ні</a>',
								trigger: 'click',
								interactive: true,
							});

							//console.log(esrc);

							esrc.appendTo($(src).find('.participants'));

							for (const [key, field] of Object.entries(field_obj)) {

								if ((field.name == 'gender')) {
									if (field.value) {
										$(esrc).find('.fields .genderlabel[value="' + field.value + '"]').click();
									}
									//$(esrc).find('input[value=' + field.value + ']').parent().click();

									//console.log(field.value);
								} else if (field.name == 'estafeta-type') {
									// console.log(field.value);
									$(esrc).find('select[name="estafeta-type"]').val(field.value).change();
									$(esrc).find('.block-title input[name=estafeta-type]').hide();

									$(esrc).find('.snaryad a[value=' + field.value + ']').addClass('active');
									checkDisabledSnaryads($(esrc).closest('.participants'));

									//$(esrc).find('.block-title input option[value='+field.value+']').click();
								} else if (field.name == 'size') {
									//console.log(field.value);
									$(esrc).find('.validate-size').val(field.value).change();

								}  else if (field.name == 'reg_country') {
									console.log(field.value);
									$(esrc).find('select[name="reg_country"]').val(field.value).change();

								} else {
									$(esrc).find('.fields .field input[name=' + field.name + ']').val(field.value);
								}

							}

						});
					} else {
						participant.runners.forEach(function (field_obj) {
							for (const [key, field] of Object.entries(field_obj)) {
								 
								$(src).find('.fields .field input[name=' + field.name + ']').val(field.value);

								if (field.name == 'gender') {
									// console.log(field.value);
									if (field.value) {
										$(src).find('.fields .field .genderlabel[value=' + field.value + ']').click();
									}
								} else if (field.name == 'size') {
									//console.log(field.value);
									$(src).find('.validate-size').val(field.value).change();

								} else if (field.name == 'reg_country') {
									//console.log(field.value);
									$(src).find('select[name="reg_country"]').val(field.value).change();
									$(src).find('select[name="reg_country"]').chosen();

								} 
							}
						});
					}


					updateTotal();

				}
			}

		}

		// console.log(input.marathons_step);
		if (input.marathons_step) {
			if (input.marathons_step == 'merch') {
				hideAll();
				$('.subtotal').attr('step', 'merch');
				$('.container.merch').show();
			}

			if (input.marathons_step == "checkout") {
				hideAll();
				$('.subtotal').attr('step', 'merch');
				$('.container.merch').show();
			}
		}

	}

	// Fill foter info on checkout page
	if ($('.woocommerce-checkout.woocommerce-page').length) {
		let data = JSON.parse(localStorage.getItem('marathons_cart'));
		$('.subtotal .total-participants span.part').text(data.marathons_event.number);
		$('.subtotal .total span.price').text(data.marathons_event.total);
	}

	console.log(JSON.parse(localStorage.getItem('marathons_cart')));
	restoreCart(JSON.parse(localStorage.getItem('marathons_cart')));


});